import { Box, useTheme } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import Header from '../../components/Header';
import { tokens } from '../../theme';

const CoordinatorReportDetails = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const token = localStorage.getItem('token');
  const { coordinatorId } = useParams();
  const [searchParams] = useSearchParams();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const startDate = searchParams.get('startDate') || '';
  const endDate = searchParams.get('endDate') || '';
  const countryId = searchParams.get('countryId') || '';

  const fetchData = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      if (countryId) params.append('countryId', countryId);
      if (startDate && endDate) {
        params.append('startDate', startDate);
        params.append('endDate', endDate);
      }
      const res = await fetch(
        `${process.env.REACT_APP_APILINK}/api/admin/coordinator-reports/${coordinatorId}/not-scanned?${params.toString()}`,
        { headers: { token } }
      );
      const data = await res.json();
      setRows(data?.success ? data.data || [] : []);
    } catch (e) {
      console.error('Error fetching coordinator not-scanned details', e);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coordinatorId]);

  const columns = [
    { field: 'departureDate', headerName: 'Departure', minWidth: 110, flex: 0.7 },
    { field: 'countryId', headerName: 'Destination', minWidth: 110, flex: 0.7 },
    { field: 'guideName', headerName: 'Guide', minWidth: 180, flex: 1 },
    { field: 'excursionName', headerName: 'Excursion', minWidth: 180, flex: 1.2 },
    { field: 'passengerName', headerName: 'Passenger', minWidth: 180, flex: 1.1 },
    { field: 'passengerEmail', headerName: 'Email', minWidth: 220, flex: 1.2 },
    { field: 'passengerPhone', headerName: 'Phone', minWidth: 140, flex: 0.8 },
    { field: 'quantity', headerName: 'Qty', minWidth: 70, flex: 0.4 },
    { field: 'contractNo', headerName: 'Contract', minWidth: 120, flex: 0.7 },
  ];

  return (
    <Box m="20px">
      <Header title="NOT SCANNED DETAILS" subtitle="Passengers who did not go (not scanned)" />
      <Box
        height="650px"
        sx={{
          '& .MuiDataGrid-root': { border: 'none' },
          '& .MuiDataGrid-cell': { borderBottom: 'none' },
          '& .MuiDataGrid-columnHeaders': { backgroundColor: colors.blueAccent[700], borderBottom: 'none' },
          '& .MuiDataGrid-virtualScroller': { backgroundColor: colors.primary[400] },
          '& .MuiDataGrid-footerContainer': { borderTop: 'none', backgroundColor: colors.blueAccent[700] },
        }}
      >
        <DataGrid rows={rows} columns={columns} getRowId={(r) => r.id} loading={loading} />
      </Box>
    </Box>
  );
};

export default CoordinatorReportDetails;

